import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertsvarService } from '../../alertsvar.service';

@Component({
  selector: 'app-additional-events',
  templateUrl: './additional-events.component.html',
  styleUrls: ['./additional-events.component.scss']
})
export class AdditionalEventsComponent {

  constructor(
    @Inject (MAT_DIALOG_DATA) public data:any,
    public alertvarservice:AlertsvarService
  ){}

}
